import { z } from 'zod';
import { hexColorSchema, idSchema, isoDateTimeSchema } from './common.js';
export const brandSchema = z.object({
    id: idSchema,
    name: z.string().min(1).max(80),
    slug: z
        .string()
        .min(1)
        .max(80)
        .regex(/^[a-z0-9-]+$/, 'slug deve ser minúsculo com hífens'),
    primary_hex: hexColorSchema.default('#E10A17'),
    logo_url: z.string().url().max(500).nullable(),
    is_active: z.boolean(),
    created_at: isoDateTimeSchema,
});
//# sourceMappingURL=brand.js.map